import { createFileRoute } from "@tanstack/react-router";
import { QuestoveryCasePage } from "@/components/blocks/work/QuestoveryCasePage";
import {
	buildPageBreadcrumb,
	buildPageSeo,
	loadPageLocale,
} from "@/lib/page-seo";

export const Route = createFileRoute("/{-$locale}/realisations/questovery")({
	component: QuestoveryCasePage,
	loader: loadPageLocale,
	head: ({ loaderData }) =>
		loaderData
			? buildPageSeo("questoveryCase", loaderData.locale, {
					structuredData: [
						buildPageBreadcrumb(loaderData.locale, ["work", "questoveryCase"]),
					],
				})
			: {},
});
